import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import Attachment from './Attachment';
import PropTypes from 'prop-types';

@injectIntl
@observer
export default class Attachments extends React.Component {
  render() {
    const { attachable, renderHidePreview } = this.props;
    
    return (
      <div className={'attachments-container'}>
        {attachable.attachments.map((attachment, idx) => (
          <Attachment
            key={idx}
            attachment={attachment}
            canEdit={() => attachable.canEditAttachments()}
            renderHidePreview={renderHidePreview}
          />
        ))}
        
      </div>
    );
  }
}

Attachments.propTypes = {
  attachable: PropTypes.object
};

Attachments.defaultProps = {
  renderHidePreview: false
};
